'use client'

export const customUrlVideo = (link: string) => {
  if (link?.includes('video.mona-cloud.com/api')) {
    return link
  }
  const originalUrl = link
  if (originalUrl && originalUrl.includes('/embed.php')) {
    const customizedUrl = originalUrl.replace('/embed.php', '/embed-customized.php')
    return customizedUrl
  }
  return link
}

// Cái này render cái video ra nè
const StudyIframe = ({
  videoUrl,
  videoName,
  savedTime = 0,
  id,
  autoPlay = true,
}: {
  videoUrl: string
  videoName: string
  savedTime: number
  id: string
  autoPlay?: boolean
}) => {
  const urlVideo = removeLinkAndAutoplay(videoUrl)
  if (!checkIsMonaVideoLink(urlVideo)) {
    return (
      <>
        <iframe
          key={videoName || ''}
          id={'video-iframe-' + id}
          width="560"
          height="315"
          src={`${urlVideo || ''}`}
          title={videoName || ''}
          allowFullScreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          className="h-full w-full object-cover"
        ></iframe>
      </>
    )
  }

  const videoSuffix = `&autoplay=${autoPlay}&time=${savedTime || 0}&draggable=true&link=${getCustomJS(urlVideo)}`

  return (
    <>
      <iframe
        key={videoName}
        id={'video-iframe-' + id}
        width="560"
        height="315"
        src={`${urlVideo}${videoSuffix}&siteColor=2F7AD9`}
        title={videoName}
        allowFullScreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        className="img-cover"
      ></iframe>
    </>
  )
}

function checkIsMonaVideoLink(uri: string) {
  return uri?.includes('video.monamedia.net') || uri?.includes('video.mona-cloud')
}

function checkIsVideoLink(uri: string) {
  return (
    uri?.includes('video.monamedia.net') ||
    uri?.includes('video.mona-cloud') ||
    (uri?.includes('/embed') && uri?.includes('https://'))
  )
}
const customJS = 'https://video.mona-cloud.com/statics/mb9802.js'
const defautlJS = `${customJS}?ver=175162653306611`
function getCustomJS(videoLink: string) {
  if (!videoLink) {
    return ''
  }
  try {
    if (videoLink?.includes(defautlJS)) {
      return videoLink.replace(defautlJS, `${customJS}?ver=2501151401`)
    } else {
      return `${customJS}?ver=2501151401`
    }
  } catch (error) {
    return videoLink
  }
}
export function removeLinkAndAutoplay(inputUrl: string): string {
  try {
    const url = new URL(inputUrl)
    url.searchParams.delete('link')
    url.searchParams.delete('autoplay')
    return url.toString()
  } catch (err) {
    // Nếu input không phải là URL hợp lệ, trả nguyên input
    return inputUrl
  }
}
const YOUTUBE_EMBED_PREFIX = 'https://www.youtube.com/embed/'
function isYouTubeLink(url: string): boolean {
  return url.includes('youtube.com') || url.includes('youtu.be')
}
function extractYouTubeVideoId(url: string): string | null {
  const regex =
    /(?:https?:\/\/)?(?:www\.|m\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  const match = url.match(regex)
  return match?.[1] || null
}
function getYouTubeEmbedUrl(url: string): string {
  const id = extractYouTubeVideoId(url)
  return id ? `${YOUTUBE_EMBED_PREFIX}${id}` : ''
}
function customizeMonaEmbedUrl(url: string): string {
  if (url.includes('/embed.php')) {
    return url.replace('/embed.php', '/embed-customized.php')
  }
  return url
}

export const VideoIframeDynamic = ({
  video_link,
  videoName,
  savedTime = 0,
  id,
  autoPlay,
}: {
  video_link: string
  videoName: string
  savedTime?: number
  id: string
  autoPlay?: boolean
}) => {
  if (!video_link) {
    return null
  }

  if (isYouTubeLink(video_link)) {
    const embedUrl = getYouTubeEmbedUrl(video_link)
    return (
      <StudyIframe
        videoUrl={embedUrl}
        savedTime={savedTime}
        videoName={videoName}
        id={id}
        autoPlay={autoPlay}
      />
    )
  }

  const processedUrl = customizeMonaEmbedUrl(video_link)
  return (
    <StudyIframe
      videoUrl={processedUrl}
      savedTime={savedTime}
      videoName={videoName}
      id={id}
      autoPlay={autoPlay}
    />
  )
}
